module.exports = __webpack_public_path__ + "media/images/admin/icons/feather-40412753ef861e7cc1dfb5e543328c12.svg";